import { Box, Flex } from '@lemonade-hq/cdk';
import parse from 'html-react-parser';
import React from 'react';
import {
  CoverageContainer,
  CoverageItem,
  CoverageItemDescription,
  CoverageItemImage,
  CoverageItemInfo,
  CoverageItemTitle,
} from './StyledElements';
import {
  CoverageItemDescriptionText,
  CoverageItemTitleText,
  StyledPill,
  StyledSection,
  StyledTitle,
  Subtitle,
} from './CoverageShared';
import type { CoverageSectionProps } from './CoverageShared';

export const DefaultVariantCoverage = React.forwardRef<HTMLDivElement, CoverageSectionProps>(
  ({ title, subtitle, coverages, itemMargin = 30, itemWidth = [210, 270], containerWidth, ...props }, ref) => {
    const renderCoverageItems = () =>
      coverages.map(({ background, backgroundDesktop, title, description, alt, pill, preElement: sideNote }) => {
        const titles = typeof title === 'string' ? [title] : title;
        const descriptions = typeof description === 'string' ? [description] : description;

        return (
          <CoverageItem
            key={titles.join()}
            alignItems="center"
            position="relative"
            flexBasis={itemWidth}
            minWidth={itemWidth}
            mx={itemMargin}
            role="listitem"
          >
            {pill && <StyledPill backgroundColor={pill.backgroundColor}>{pill.text}</StyledPill>}
            {sideNote}
            <CoverageItemImage alt={alt} src={backgroundDesktop || background} width={165} height={165} />
            <CoverageItemInfo tabIndex={0}>
              <CoverageItemTitle flexDirection="column">
                {titles.map(t => (
                  <CoverageItemTitleText key={t}>{parse(t)}</CoverageItemTitleText>
                ))}
              </CoverageItemTitle>
              <CoverageItemDescription flexDirection="column">
                {descriptions.map(d => (
                  <CoverageItemDescriptionText key={d} style={{ whiteSpace: 'pre-line' }}>
                    {parse(d)}
                  </CoverageItemDescriptionText>
                ))}
              </CoverageItemDescription>
            </CoverageItemInfo>
          </CoverageItem>
        );
      });

    return (
      <StyledSection ref={ref} mb={0} pt={[45, 100]} width={1} contain="paint" {...props}>
        <Flex gap="20px" flexDirection="column">
          <StyledTitle tabIndex={0}>{parse(title)}</StyledTitle>
          <Box width={['80%', '100%']} mx="auto">
            <Subtitle tabIndex={0}>{parse(subtitle)}</Subtitle>
          </Box>
        </Flex>

        <CoverageContainer
          mt={[45, 80, 80]}
          px={[40, 0]}
          pb={[50, 100, 100, 100]}
          width={[1, 980, 1]}
          justifyContent={['flex-start', 'center']}
          flexWrap={['nowrap', 'wrap']}
          containerWidth={containerWidth}
          role="list"
        >
          {renderCoverageItems()}
        </CoverageContainer>
      </StyledSection>
    );
  },
);
